<template>
  <b-modal id="modal-2" ref="inqModal"  :visible="isVisible" :title="$t('inquiry.inquiryLong')" @ok="handleOK" @close="handleCancel">
    <!--        ref="inquiryModal"-->
    <b-container>
      <div class="row dropdown-row" style="padding-bottom: 20px">
        <div class="col-lg-12">
          {{ $t('inquiry.text') }}
        </div>
      </div>
      <!--                                    <div v-if="user.isAnonym" class="row dropdown-row">-->
      <!--            v-if="anonym"-->
      <div class="row dropdown-row" v-if="anonym">
        <div class="col-lg-6">
          {{ $t('quotation.name') }}
        </div>
        <div class="col-lg-6">
          <b-form-input size="sm" ref="inputName" :state="nameState" v-on:input="this.nameInput"  v-model="model.name"></b-form-input>
        </div>
      </div>
      <div class="row dropdown-row" v-if="anonym">
        <div class="col-lg-6">
          {{ $t('quotation.surname') }}
        </div>
        <div class="col-lg-6">
          <b-form-input size="sm" ref="inputSurname" :state="surnameState" v-on:input="this.surnameInput"  v-model="model.surname"></b-form-input>
        </div>
      </div>
      <div class="row dropdown-row" v-if="anonym">
        <div class="col-lg-6">
          {{ $t('quotation.company') }}
        </div>
        <div class="col-lg-6">
          <b-form-input size="sm" ref="inputCompany" :state="companyState" v-on:input="this.companyInput"  v-model="model.company"></b-form-input>
        </div>
      </div>
      <div class="row dropdown-row" v-if="anonym">
        <div class="col-lg-6">
          {{ $t('quotation.countrie') }}
        </div>
        <div class="col-lg-6">
          <b-form-select v-model="model.country" ref="inputCountry" v-on:input="this.countryInput" :state="countryState" size="sm" :options="laender"></b-form-select>
        </div>
      </div>
      <div class="row dropdown-row" v-if="anonym">
        <div class="col-lg-6" style="float: left; line-height: 26px">
          {{ $t('quotation.mail') }}
        </div>
        <div class="col-lg-6" style="float: right">
          <b-form-input size="sm" ref="inputMail" v-on:input="this.mailInput" :state="mailState" v-model="model.quotationMail"></b-form-input>
        </div>
      </div>
      <div class="row dropdown-row" v-if="anonym">
        <div class="col-lg-6">
          {{ $t('quotation.phone') }}
        </div>
        <div class="col-lg-6">
          <b-form-input size="sm" ref="inputPhone" :state="phoneState" v-on:input="this.phoneState" v-model="model.phone"></b-form-input>
        </div>
      </div>
      <div class="row dropdown-row" style="padding-bottom: 0px">
        <div class="col-lg-12">
          {{ $t('quotation.comment') }}
        </div>
      </div>
      <div class="row dropdown-row" style="padding-top: 0px">
        <div class="col-lg-12">
          {{model.comment}}
          <b-form-textarea rows="4" v-model="model.kommentar">
          </b-form-textarea>
        </div>
      </div>
      <div class="row dropdown-row" style="padding-bottom: 0px" v-if="anonym">
        <div class="termsdesc col-lg-12">
          {{$t('dsgvo.preLink')}}<a :href="$t('dsgvo.link')" target="_blank">{{$t('dsgvo.link')}}</a>{{$t('dsgvo.postLink')}}
        </div>
      </div>
      <div class="row dropdown-row" style="padding-top: 5px" v-if="anonym">
        <div class="col-lg-12">
          <b-form-checkbox ref="inputTerms" v-on:input="termsInput" :state="termsState" v-model="termsChecked" name="checkbox-terms">
            {{$t('dsgvo.accept')}}
          </b-form-checkbox>
        </div>
      </div>
    </b-container>
    <template v-slot:modal-footer>
      <div class="w-100">
        <b-button
            variant="primary"
            class="float-right"
            @click="handleOK">
          {{$t('inquiry.inquiryLong')}}
        </b-button>
        <b-button
            style="margin-right: 10px"
            variant="secondary"
            class="float-right"
            @click="handleCancel">
          {{$t('general.cancel')}}
        </b-button>
      </div>
    </template>
  </b-modal>
  <!--    </div>-->
</template>

<script>
import matomoTracking from "@/mixins/matomoTracking";

export default {
  name: "RequestInquiry",
  props: ['model'],
  mixins: [matomoTracking],
  data() {
    return {
      countryState: null,
      mailState: null,
      nameState: null,
      surnameState: null,
      companyState: null,
      phoneState: null,
      termsState: null
    }
  },
  computed: {
    isVisible: function () {
      return this.$store.getters.isInquiryModalVisible === true;
    },
    anonym: function() {
      return this.$store.getters.getUserData.anonym;
    },
    laender: function () {
      return this.$t('countries.all');
    }
  },
  methods: {
    handleOK() {
      this.trackEvent('Konfigurator', 'Alternative angefragt')
      if (this.anonym) {
        if (!(this.$refs.inputCountry.value == null) &&
            !(this.$refs.inputName.value == null) &&
            !(this.$refs.inputSurname.value == null) &&
            !(this.$refs.inputCompany.value == null) &&
            this.mailIsValid() &&
            this.termsAccepted()) {

          this.$store.dispatch('saveInquiry', this.model);
          this.$store.commit('setShowInquiryModal', false);
        } else {
          if (this.$refs.inputCountry.value == null || this.$refs.inputCountry.value.length === 0) {
            this.countryState = false;
          }
          if (this.$refs.inputName.value == null || this.$refs.inputName.value.length === 0) {
            this.nameState = false
          }
          if (this.$refs.inputSurname.value == null || this.$refs.inputSurname.value.length === 0) {
            this.surnameState = false
          }
          if (this.$refs.inputCompany.value == null || this.$refs.inputCompany.value.length === 0) {
            this.companyState = false
          }
          if (!this.mailIsValid()) {
            this.mailState = false;
          }
          if (!this.termsAccepted()) {
            this.termsState = false;
          }
        }
      } else {
        this.$store.dispatch('saveInquiry', this.model);
        this.$store.commit('setShowInquiryModal', false);
      }
    },
    termsAccepted() {
      return this.termsChecked || !this.anonym;
    },
    mailIsValid() {
      if (this.$refs.inputMail.value !== null) {
        if (this.$refs.inputMail.value.indexOf("@") !== -1 && this.$refs.inputMail.value.indexOf(".") !== -1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false
      }
    },
    mailInput() {
      this.mailState = null
    },
    phoneInput() {
      this.phoneState = null
    },
    countryInput() {
      this.countryState = null
    },
    nameInput() {
      this.nameState = null
    },
    surnameInput() {
      this.surnameState = null
    },
    companyInput() {
      this.companyState = null
    },
    termsInput() {
      this.termsState = null
    },
    handleCancel() {
      //this.model.visible = false
      this.$store.commit('setShowInquiryModal', false);
      //this.$refs['inqModal'].hide()
    },
    showup() {
      //this.$refs.inquiryModal.show();
    }
  }
}
</script>

<style scoped>
.row {
  padding-bottom: 10px;
}
.termsdesc {
  font-size: smaller;
}
</style>